export const FETCH_EDITOR_TOKENS = 'fetchEditorTokens';
export const UPDATE_ACTIVE_SORT_FIELD_TOKENS = 'updateActiveSortFieldTokens';
export const UPDATE_SEARCH_TOKENS = 'updateSearchTokens';
export const CLEAR_SEARCH_TOKENS = 'clearSearchTokens';
export const DELETE_TOKEN = 'deleteToken';
